import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IParentType } from "src/models/HumanResources/ParentTypes.models";

interface ParentTypeState {
  parentTypes: IParentType[];
  parentTypeToEdit: IParentType | null;
}

const initialState: ParentTypeState = {
  parentTypes: [],
  parentTypeToEdit: null,
};

const ParentTypeSlice = createSlice({
  name: "ParentType",
  initialState,
  reducers: {
    setParentTypeList: (state, action: PayloadAction<IParentType[]>) => {
      state.parentTypes = action.payload;
    },
    concatListParentType: (
      state: ParentTypeState,
      action: PayloadAction<IParentType[]>
    ) => {
      state.parentTypes = [...state.parentTypes.concat(action.payload)];
    },
    setParentTypeToEdit: (state, action: PayloadAction<IParentType | null>) => {
      state.parentTypeToEdit = action.payload;
    },
    addParentType: (state, action: PayloadAction<IParentType>) => {
      state.parentTypes.push(action.payload);
    },
    updateParentType: (state, action: PayloadAction<IParentType>) => {
      let itemIndex = state.parentTypes.findIndex(
        item => item.parentTypeId === action.payload.parentTypeId
      );
      if (itemIndex !== -1) state.parentTypes[itemIndex] = action.payload;
    },
    deleteParentType: (state, action: PayloadAction<number>) => {
      const newArray = state.parentTypes.filter(
        item => item.parentTypeId !== action.payload
      );
      state.parentTypes = newArray;
    },
  },
});

export const {
  setParentTypeList,
  concatListParentType,
  setParentTypeToEdit,
  addParentType,
  updateParentType,
  deleteParentType,
} = ParentTypeSlice.actions;

export default ParentTypeSlice.reducer;
